import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import App from './App';
import LogoutPage from './Pages/LogoutPage';

const LOGOUT_URL_PATH = '/logout/redirect';
const WILD_CARD_PATH = '*';

const AppRouter: React.FC = () => {
  const auth = useAuth();

  return (
    <Routes>
      <Route path={LOGOUT_URL_PATH} element={<LogoutPage auth={auth} />} />
      <Route path={WILD_CARD_PATH} element={<App auth={auth} />} />
    </Routes>
  );
};

export default AppRouter;
